export function fulltextDate(date) {

    if (date === undefined) {
        // we can't do anything with this
        return '';
    }

    // check incoming date format
    if ( Number.isInteger( parseInt(date.substr(4,1)) ) ) {
        // 12-25-2020
        const thedate = new Date(date.substr(6,4),(date.substr(3,2) -1 ),date.substr(0,2));

        return thedate.toLocaleString( 'default', { month: 'short' }  ) + ' ' +
               thedate.toLocaleString( 'default', { day:   'numeric'} ) + ', ' + 
               thedate.toLocaleString( 'default', { year:  'numeric'} );

    } else if ( Number.isInteger( parseInt(date.substr(2,1)) ) ) {
        // 2020-12-25
        const thedate = new Date(date.substr(0,4),(date.substr(5,2) -1 ),date.substr(8,2));

        return thedate.toLocaleString( 'default', { month: 'short' }  ) + ' ' +
               thedate.toLocaleString( 'default', { day:   'numeric'} ) + ', ' + 
               thedate.toLocaleString( 'default', { year:  'numeric'} );

    }
}